// The family-detail route segment under `/admin/nlp-prompt-catalog`. Clicking a
// row drills into `/admin/nlp-prompt-catalog/:familyId`. Mirrors the feature-flags
// `:name` detail segment.
export const FAMILY_DETAIL_SEGMENT = ':familyId'

// The create-family route segment: `/admin/nlp-prompt-catalog/new`. A static
// segment, so React Router ranks it above the `:familyId` param.
export const FAMILY_CREATE_SEGMENT = 'new'
